import React from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import CartItem from "./CartItem";
import Grid from "@material-ui/core/Grid";
import { withRouter } from "react-router-dom";
//import Container from '@material-ui/core/AppBar';
import ChangeLocation from "./changeLocation";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/KeyboardBackspace";
import Slide from "@material-ui/core/Slide";
import ConfirmationDialog from "./confirmbox";

import "./item.css";

import Container from "@material-ui/core/Container";
import INBOX from "./INBOX";
import Divider from "@material-ui/core/Divider";

//import { positions } from '@material-ui/system';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Boxer(props) {
  const [open, setOpen] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  function back() {
    props.history.goBack();
  }

  let count = 0;
  const z = [];
  let pay = 0;
  let tax = 0;
  for (let key in props.cart) {
    if (props.cart[key] !== undefined) {
      pay += props.cart[key].quantity * props.cart[key].customerPayable;
      tax += props.cart[key].quantity * props.cart[key].PriceMap.TotalTax;
    }
  }
  let bill = pay - tax;
  bill = bill.toFixed(2);
  pay = pay.toFixed(2);
  tax = tax.toFixed(2);

  for (let key in props.cart) {
    if (props.cart[key] !== undefined) {
      count += props.cart[key].quantity;

      z.push(<CartItem cat={props.cart[key]} key={props.cart[key].itemId} />);
    }
  }

  // console.log("boxer2");

  return (
    <div>
      <span style={{ float: "right", marginRight: 10 }}>
        <Button
          variant="contained"
          size="medium"
          style={{ color: "white", backgroundColor: "#3D83E1" }}
          onClick={handleClickOpen}
        >
          Place Order
        </Button>
      </span>

      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        {/* ---------------------------------------------*--------------*---------------------------------- */}

        <Grid
          container
          alignItems="center"
          spacing={1}
          style={{
            backgroundColor: "#45A04A",
            position: "fixed",
            top: 0,
            zIndex: 100,
            margin: "0px"
          }}
        >
          <Grid item xs={2} style={{ marginLeft: "10px" }}>
            <IconButton
              edge="start"
              style={{ color: "white" }}
              onClick={handleClose}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
          </Grid>
          <Grid item xs={8} style={{ fontSize: "18px", color: "white" }}>
            Cart
          </Grid>
        </Grid>
        {/* ------------------------------------------------------------------- */}
        <Grid
          container
          style={{
            position: "fixed",
            backgroundColor: "white",
            bottom: 0,
            zIndex: 100,
            width: "100%",
            height: "150px",
            margin: "0px",
            boxShadow:
              "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)"
          }}
          alignItems="center"
        >
          <Grid item xs={12} style={{ padding: 0 }}>
            <Grid container alignItems="center">
              <Grid item xs={6}>
                <span style={{ marginLeft: 10, color: "#666666 " }}>
                  Deliver to
                </span>
              </Grid>
              <Grid item xs={6}>
                <span
                  style={{ marginRight: 10, color: "#F1F1F1 ", float: "right" }}
                >
                  <ChangeLocation back={back} />
                  {/* <Button
                    style={{ color: "#3D83E1", paddingRight: 0 }}
                    onClick={back}
                    size="small"
                    className="sc2"
                  >
                    Change Location{" "}
                  </Button>{" "} */}
                </span>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ padding: 0, margin: 0 }}>
            <span style={{ marginLeft: 10 }}>
              {props.match.params.stationCode} -{props.match.params.StaN}
            </span>
          </Grid>

          <Grid item xs={12} style={{ padding: 0, margin: 0 }}>
            <span style={{ marginLeft: 10 }}>
              {" "}
              ON {props.match.params.doj}{" "}
            </span>
          </Grid>
          <Grid item xs={12} style={{ padding: 0, margin: 0 }}>
            <Typography align="center">
              {" "}
              <INBOX  tax={tax} topay={pay} />
            </Typography>
          </Grid>
        </Grid>

        <Container style={{ marginTop: "70px", marginBottom: "156px" }}>
          <Grid container alignItems="center" style={{ marginBottom: "15px" }}>
            <Grid item xs={7} className="sudo">
              You have {count} items in your cart
            </Grid>
            {/* <Grid item xs={1}>
            {" "}
          </Grid> */}
            <Grid item xs={5}>
              <span style={{ float: "right" }}>
                {" "}
                <ConfirmationDialog />
              </span>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            style={{ backgroundColor: "#F1F1F1", marginBottom: "5%" }}
          >
            {z}
            <Grid item xs={12} style={{ marginTop: "3%" }}>
              <Grid container alignItems="center">
                <Grid item md={5} xs={4} />
                <Grid item md={6} xs={8}>
                  <Button
                    variant="outlined"
                    style={{ color: "#3D83E1", borderColor: "#3D83E1" }}
                    onClick={handleClose}
                    size="small"
                    className="sc"
                  >
                    Add more items
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            alignItems="center"
            style={{ backgroundColor: "#F1F1F1" }}
          >
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={6}>
                  <span style={{ float: "left", marginLeft: 5 }}>To Pay</span>
                </Grid>
                <Grid item xs={6}>
                  <span
                    style={{
                      float: "right",
                      marginRight: 5,
                      color: "#3D83E1",
                      fontWeight: "bold"
                    }}
                  >
                    ₹ {pay}
                  </span>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider style={{ marginBottom: 3, marginTop: 3 }} />
              <Grid container alignItems="center">
                <Grid item xs={6}>
                  <span style={{ float: "left", marginLeft: 5 }}>
                    Total Taxes
                  </span>
                </Grid>
                <Grid item xs={6}>
                  <span style={{ float: "right", marginRight: 5 }}>
                    ₹ {tax}
                  </span>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={6}>
                  <span style={{ float: "left", marginLeft: 5 }}>
                    Total Bill
                  </span>
                </Grid>
                <Grid item xs={6}>
                  <span style={{ float: "right", marginRight: 5 }}>
                    ₹ {bill}
                  </span>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>

        {/* <Container>
   <Grid container spacing={5} >
      <Grid item md={6} xs={12}>
        {z}
      </Grid>
      <Grid item xs={12} md={6}>
     
       <Paper style={{height:150,backgroundColor:"#f2f2f2", marginTop:4}}>
         
     <Typography variant="body1" align="center"  >
     <span style={{fontSize:20}}> To Pay &nbsp; &nbsp; </span>  <span style={{color:"#2063e8",fontSize:25}}>₹{pay}</span>
      </Typography>  
      <hr/>
      <Typography variant="body1" align="center"  >
      <span style={{fontSize:20}}>Total Taxes  &nbsp; &nbsp; ₹{tax} </span>
      </Typography>   
      <Typography variant="body1" align="center"  >
      <span style={{fontSize:20}}> Total bill   &nbsp; &nbsp;    ₹{bill}</span>
      </Typography>   
                    
     </Paper>    
     
    </Grid>
   </Grid>
  </Container> */}
      </Dialog>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    cart: state.menuR.cart
  };
};
export default connect(mapStateToProps)(withRouter(Boxer));
